import { UIAction, setVisitCode, hideSidePanel } from '../ui/actions';
import { VisitsAction, setVisit, setVisitConfig, setVisitConfigFetching, setVisits, setVisitsFetching } from './actions';
import { all, call, fork, put, select, take, takeLatest, delay } from 'redux-saga/effects';

import { ApiResponse } from 'apisauce';
import { HealAPI } from '../../healApi';
import { RootState } from '../types';
import { Visit } from './types';

function* getVisits(): any {
  const state: RootState = yield select((s) => s);
  if (state.ui.markets && state.ui.markets.length > 0) {
    yield put(setVisitsFetching(true));
    const result = yield call(HealAPI.fetchVisits, state.ui.markets, 600, state.ui.visitStatus, state.ui.date);
    yield put(setVisits(result && result.data && result.data.results ? result.data.results : []));
    yield put(setVisitsFetching(false));
  }
}

function* getVisit(data: { visitCode: string; refresh?: boolean }): any {
  const { visitCode, refresh } = data;
  yield put(setVisitsFetching(true));
  const result: ApiResponse<Visit> = yield call(HealAPI.fetchVisit, visitCode);

  if (result.ok) {
    yield put(setVisit(result.data!));
  }
  yield put(setVisitsFetching(false));

  if (refresh) {
    yield delay(3000);
    yield fork(getVisit, { visitCode });
  }
}

function* getVisitsData() {
  try {
    yield all([fork(getVisits)]);
  } catch (e: any) {
    // error handling
  }
}

export function* visitsFlow() {
  yield takeLatest(
    ['PAGE_DID_MOUNT/Visits', 'PAGE_DID_MOUNT/Map', UIAction.SET_MARKETS, UIAction.SET_VISIT_STATUS, UIAction.SET_DATE, VisitsAction.CHANGE_PROVIDER, VisitsAction.REFRESH_VISITS],
    getVisitsData
  );
}

export function* fetchVisitFlow() {
  while (true) {
    const { data } = yield take(VisitsAction.FETCH_VISIT);
    yield fork(getVisit, data);
  }
}

export function* getVisitConfig(): any {
  yield put(setVisitConfigFetching(true));
  const result = yield call(HealAPI.fetchVisitConfig, true);
  if (result.data) {
    yield put(setVisitConfig(result.data.properties));
  }
  yield put(setVisitConfigFetching(false));
}

function* closeSidePanel() {
  yield put(setVisitCode(''));
  yield put(hideSidePanel());
}

export function* closeSidePanelOnUnmountFlow() {
  yield takeLatest(
    ['PAGE_WILL_UNMOUNT/Visits', 'PAGE_WILL_UNMOUNT/OnSiteVisits', 'PAGE_WILL_UNMOUNT/Map', 'PAGE_WILL_UNMOUNT/Patient', 'PAGE_WILL_UNMOUNT/HubSessionManager'],
    closeSidePanel
  );
}
